'use client'

import TrackedLink from '@/components/utils/tracking/tracked-link-button'

export default function CalendarEventPlaceholder({ dayJsDate, isMonthView }) {
  if (isMonthView) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 rounded bg-neutral-blue p-5 py-10 text-center md:p-32">
        <p className="text-lg">You don't have any events this week.</p>
        <TrackedLink
          eventName="Driver Calendar Search Leagues Clicked"
          href="/leagues"
          className="inline-flex items-center justify-center gap-2 rounded-sm border border-neutral-blue-900 bg-neutral-blue-900 px-4 py-2 text-center text-sm font-medium text-shades-0 transition-colors duration-200 hover:bg-neutral-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
        >
          Search Leagues
        </TrackedLink>
      </div>
    )
  }
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded bg-neutral-blue p-5 py-10 text-center text-sm md:p-32 md:text-lg">
      <p className="md:text-lg">
        You don't have any events on {dayJsDate.format('dddd DD MMMM')}
      </p>
      <p className="text-shades-0">
        <span className="text-neutral-blue-400">
          Fancy racing on this day?{' '}
        </span>
        {dayJsDate.format('dddd')}
      </p>
      <TrackedLink
        className="inline-flex items-center justify-center gap-2 rounded-sm border border-neutral-blue-900 bg-neutral-blue-900 px-4 py-2 text-center text-sm font-medium text-shades-0 transition-colors duration-200 hover:bg-neutral-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
        href={`/leagues?days=${dayJsDate.format('ddd').toLowerCase()}`}
        eventName="Driver Calendar Search Leagues Clicked"
      >
        Search Leagues
      </TrackedLink>
    </div>
  )
}
